import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import enCommon from "../locales/en/common.json"
import deCommon from "../locales/de/common.json"

const savedLanguage = localStorage.getItem("language") || "en";
const resources = {
  en: {
    common: enCommon
  },
  de: {
    common: deCommon
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,         // default language
    fallbackLng: "en",
    ns: ["common"],
    defaultNS: "common",
    interpolation: {
      escapeValue: false
    }
  })

export default i18n